/** The style props of the Typography components; each picks the ones it supports */
export type TypographyStyleProps = {
    size?: 'xs' | 'sm' | 'base' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl';
    weight?: 'normal' | 'medium' | 'semibold' | 'bold';
    /** The `--color-content-*` design tokens */
    color?:
        | 'primary'
        | 'secondary'
        | 'tertiary'
        | 'subdued'
        | 'primary-inverse'
        | 'secondary-inverse'
        | 'tertiary-inverse'
        | 'subdued-inverse'
        | 'positive'
        | 'warning'
        | 'negative'
        | 'informative'
        | 'highlighted';
    decoration?: 'underline' | 'strikethrough';
    transform?: 'uppercase' | 'lowercase' | 'capitalize';
    italic?: boolean;
    tabularNums?: boolean;
    truncate?: boolean;
    lineClamp?: number;
};

/** The `typography.css` modifier classes for a set of style props, shared by Text and Title */
export const typographyClasses = (props: TypographyStyleProps) => [
    props.size && `ui-text--${props.size}`,
    props.weight && `ui-text--${props.weight}`,
    props.color && `ui-text--${props.color}`,
    props.decoration && `ui-text--${props.decoration}`,
    props.transform && `ui-text--${props.transform}`,
    {
        'ui-text--italic': props.italic,
        'ui-text--tabular-nums': props.tabularNums,
        'ui-text--truncate': props.truncate,
        'ui-text--line-clamp': !props.truncate && !!props.lineClamp,
    },
];

/** Inline style carrying the `lineClamp` count to `.ui-text--line-clamp` */
export const typographyStyle = (props: TypographyStyleProps) => (props.lineClamp && !props.truncate ? { '--ui-text-lines': props.lineClamp } : undefined);
